/* The Broward Design Center — lightweight localStorage wishlist (CLAUDE.md §10).
   No app required. Hearts on product cards toggle saved handles; the wishlist
   page renders each saved piece via an alternate product template
   (/products/{handle}?view=wishlist-card, which uses {% layout none %}). */
(function () {
  var KEY = 'bdc_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    updateCounts();
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1; // true when added
  }

  function updateCounts() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function bindButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (btn.dataset.wlBound) return;
      btn.dataset.wlBound = '1';
      var handle = btn.getAttribute('data-wishlist-toggle');
      var active = has(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var added = toggle(handle);
        btn.classList.toggle('is-active', added);
        btn.setAttribute('aria-pressed', added ? 'true' : 'false');
        if (!added && document.querySelector('[data-wishlist-grid]')) {
          var card = btn.closest('[data-wishlist-card]');
          if (card) { card.remove(); reflectEmpty(); }
        }
      });
    });
  }

  function reflectEmpty() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!grid || !empty) return;
    empty.hidden = grid.querySelectorAll('[data-wishlist-card]').length > 0;
  }

  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var handles = read();
    var empty = document.querySelector('[data-wishlist-empty]');
    grid.innerHTML = '';
    if (!handles.length) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    handles.forEach(function (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '?view=wishlist-card', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('[data-wishlist-card]');
          if (card) { grid.appendChild(card); bindButtons(card); }
        })
        .catch(function () {});
    });
  }

  function init() {
    bindButtons();
    updateCounts();
    renderGrid();
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }

  // Re-bind hearts after theme AJAX (load-more, quick view, section reload).
  document.addEventListener('shopify:section:load', function () { bindButtons(); });
  document.addEventListener('bdc:cards:loaded', function () { bindButtons(); });

  window.BDCWishlist = { read: read, toggle: toggle, has: has };
})();
